import { PriorCarrierName } from "@covertree/new-business-graphql";

export function mapInsuranceCarrierName(value: string) {
  if (Object.keys(PriorCarrierName).includes(value)) {
    return PriorCarrierName[value];
  }
  return value;
}

export default mapInsuranceCarrierName;
